module.exports = __webpack_public_path__ + "static/media/venda.c2baff77.png";